import { render, staticRenderFns } from "./TVPower.vue?vue&type=template&id=48940a3f"
import script from "./TVPower.vue?vue&type=script&lang=js"
export * from "./TVPower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports